import React from 'react';
import { IconProps } from './types';

export const GooglePlayLogo = (props: IconProps) => {
  const { size = 20, color = '#FFF', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 26'
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M.44 1.035c-.072.228-.11.492-.11.787v22.356c0 .295.038.559.11.787L12.405 13 .44 1.035zm.985 24.926c.417.1.926.01 1.473-.3l14.136-8.033-3.64-3.639-11.97 11.972zm16.872-9.05l4.314-2.45c1.412-.804 1.412-2.117 0-2.92l-4.316-2.453L14.385 13l3.912 3.912zm-1.265-8.54L2.898.34C2.351.029 1.842-.061 1.424.04l11.97 11.97 3.638-3.639z'
        clipRule='evenodd'
      />
    </svg>
  );
};
